import ReactGA from 'react-ga4';

// Initialize Google Analytics
export const initGA = () => {
  const measurementId = 'G-XP0YLPH3VF';

  // Only initialize in production or if explicitly enabled
  const isProduction = process.env.NODE_ENV === 'production';

  if (isProduction || process.env.REACT_APP_GA_ENABLED === 'true') {
    ReactGA.initialize(measurementId, {
      gaOptions: {
        siteSpeedSampleRate: 100, // Track site speed
      },
      gtagOptions: {
        send_page_view: false, // We'll manually track page views
      },
    });
    console.log('Google Analytics initialized');
  } else {
    console.log('Google Analytics disabled in development');
  }
};

// Track page views
export const trackPageView = (path, title) => {
  if (process.env.NODE_ENV === 'production' || process.env.REACT_APP_GA_ENABLED === 'true') {
    ReactGA.send({
      hitType: 'pageview',
      page: path,
      title: title
    });
  }
};

// Track custom events
export const trackEvent = (category, action, label = null, value = null) => {
  if (process.env.NODE_ENV === 'production' || process.env.REACT_APP_GA_ENABLED === 'true') {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  }
};

// Track user signup
export const trackSignup = (method = 'email') => {
  trackEvent('User', 'Sign Up', method);
};

// Track user login
export const trackLogin = (method = 'email') => {
  trackEvent('User', 'Login', method);
};

// Track logout
export const trackLogout = () => {
  trackEvent('User', 'Logout');
};

// Track relationship creation
export const trackRelationshipCreated = () => {
  trackEvent('Relationship', 'Created');
};

// Track daily entry submission
export const trackDailyEntrySubmit = () => {
  trackEvent('Activity', 'Daily Entry Submitted');
};

// Track navigation
export const trackNavigation = (destination) => {
  trackEvent('Navigation', 'Click', destination);
};

// Track errors
export const trackError = (errorMessage) => {
  trackEvent('Error', 'Exception', errorMessage);
};
